"use strict";

//Modules

//Components
import Header from './components/header';
import AOS from 'aos';
import ModSliderSolucoes from './modulos/modulo-slider_de_solucoes';
import ModSliderClientes from './modulos/modulo-slider_de_clientes';
import ModSimulador from './modulos/modulo-simulador';
import Formularios from './components/form_wpforms';
import PedidosHits from './pedidos/pedidos-hits';

export default class App {
    constructor(){

        //Parts
        new Header()

        AOS.init({
            duration: 1500
        });

        const ModuloFormulariosDeContato = document.querySelector('.modulo-formularios_de_contato')
        const ModuloSliderSolucoes = document.querySelector('.modulo-slider_de_solucoes')
        const ModuloSliderClientes = document.querySelector('.modulo-slider_de_clientes')
        const ModuloSimulador = document.querySelector('.modulo-simulador')
        
        const ModuloPedidoHits = document.querySelector('.modulo-pedidos_plano_hits')

        ModuloSliderSolucoes ? new ModSliderSolucoes() : null        
        ModuloSliderClientes ? new ModSliderClientes() : null     
        ModuloSimulador ? new ModSimulador() : null   
        ModuloFormulariosDeContato ? new Formularios() : null
        
        ModuloPedidoHits ? new PedidosHits() : null
        

    }
}

new App();